import {Partners} from "../types/types";

export const partnersData: Partners[] = [
  {
    id: 'bmc_soft',
    title: 'ООО «БМК-СОФТ»',
    description: [
      'БМК Софт разрабатывает и внедряет системы цифровизации производственных и бизнес-процессов для промышленных и IT-компаний'
    ],
    images: require('../../shared/assets/images/partners/bmc.png'),
    site: 'https://bmc-soft.ru/',
    email: 'contact@bmksoft.info',
    phone: '+7 (4942) 41-93-11',
  },
  {
    id: 'pao_severstal',
    title: 'ПАО «Северсталь»',
    description: [
      'ПАО «Северсталь» — вертикально-интегрированная горно-металлургическая компания, создающая новые продукты и комплексные решения из стали вместе с клиентами и партнерами.\n'
    ],
    images: require('../../shared/assets/images/partners/pao_severstal.png'),
    site: 'https://severstal.com/rus/',
    email: 'severstal@severstal.com',
    phone: '+7 (8202) 53 0900',
  },
  // {
  //   id: 'monitor-electric',
  //   title: 'Монитор Электрик',
  //   description: [
  //     'Монитор Электрик — ведущий российский производитель программного обеспечения в области оперативно-технологического и ситуационного управления для электроэнергетики.\n'
  //   ],
  //   images: require('../../shared/assets/images/partners/monitor-electric.png'),
  //   site: 'https://monitel.ru/',
  //   email: 'info@monitel.ru',
  //   phone: '+7 (495) 258-80-90',
  //   infoMonitorElectric: true,
  // },
  {
    id: 'gaz-technologies',
    title: 'Новые технологии газовой отрасли',
    description: [
      'Ассоциация объединяет усилия отечественных предприятий в области\n' +
      'разработки и внедрения передовых технологий в производстве оборудования\n' +
      'для добычи, транспортировки и переработки природного газа;\n' +
      'унифицированных технических решений.'
    ],
    images: require('../../shared/assets/images/partners/gaz-technologies.png'),
    site: 'https://www.newgaztech.ru/',
    email: 'info@newgaztech.ru',
    phone: '+7 (495) 609-03-55',
    infoGazTechnologies: true,
  },
  {
    id: 'energy-industry',
    title: 'Энергетика и промышленность России',
    description: [
      'Ведущая отраслевая газета и интернет-портал. Выпускается с 2000 года.',
      'Сайт газеты\n' +
      'входит в ТОП-10 рейтинга СМИ ТЭК по версии «Медиалогии», освещает вопросы\n' +
      'электроэнергетики, энергетического машиностроения, электроники и смежных отраслей.',
      'Экспертные мнения, интервью, научные разработки и нормативно-правовая база.',
      '«Энергетика. Медиа» (газета «Энергетика и промышленность России»)',
      '191040, г. Санкт-Петербург, Лиговский пр, 73, БЦ «Лиговка», оф. 401'
    ],
    images: require('../../shared/assets/images/partners/EPR_Logo.png'),
    site: 'https://www.eprussia.ru/',
    email: 'office@eprussia.ru',
    phone: '+7 (812) 346-50-15',
  },
  // {
  //   id: 'nord',
  //   title: 'ГК «Северная Компания», «НОРД», «Авитон», «Петерпайп» и «ПО Катион»',
  //   description: [
  //     'ГК «Северная Компания», «НОРД», «Авитон», «Петерпайп» и «ПО Катион» — единая экосистема в теплоэнергетике: проектируем и строим котельные и тепловые сети «под ключ», выпускаем собственные котлы и мини‑котельные, трубы и решения для ИПУГ, а также развиваем собственные IT‑продукты на базе ИИ для управления и сервисной поддержки инженерной инфраструктуры по всей России.'
  //   ],
  //   images: require('../../shared/assets/images/partners/nord.png'),
  // },
  {
    id: 'servicegazstroy',
    title: 'СЕРВИСГАЗСТРОЙ',
    description: [
      'Гюнтер Шванк изобрел первый газовый инфракрасный излучатель более 90 лет назад. С тех пор наша\n' +
      'деятельность была сосредоточена на "тепле" - обязательном условии для благополучия каждого.',
      'Сегодня мы\n' +
      '                предлагаем энергосберегающие, инновационные и надежные решения для отопления, охлаждения, вентиляции\n' +
      '                промышленных, торговых и логистических помещений. Многолетний опыт, технологически продвинутое\n' +
      '                оборудование и высокие стандарты качества позволили Schwank стать мировым лидером в сегменте газовых\n' +
      '                инфракрасных излучателей и удерживать свои позиции на протяжении десятилетий.',
        'В России наш путь начался\n' +
        '                в 1996 году. Уже 30 лет климатические системы Schwank производятся на заводе Сибшванк в Тюмени. На\n' +
        '                складе всегда есть большой запас продукции и запасных частей. Мы предлагаем профессиональное решение для\n' +
        '                создания микроклимата в каждом отдельно взятом помещении. Для этого в нашей номенклатуре темные и\n' +
        '                светлые газовые инфракрасные излучатели, электрические инфракрасные излучатели, газовые теплогенераторы,\n' +
        '                воздушные завесы, приточно-вытяжные установки.',
        'Мы постоянно развиваемся, поэтому в 2025 году мы\n' +
        '                расширили штат профессиональными техническими специалистами и открыли новое направление – подбор,\n' +
        '                продажа, техническое обслуживание горелочного оборудования итальянского бренда Ecoflam.',
        'Внедрение систем отопления «под ключ» возможно благодаря нашим партнерам ООО «СервисГазСтрой» (г. Вологда). На протяжении 12 лет эта инжиниринговая компания реализует проекты различной сложности на территории всей России. Специалисты компании осуществляют подбор оборудования, разработку проекта, монтаж, пуско-наладку и последующее техническое обслуживание. Комплексный подход, профессиональные компетенции, знание оборудования  позволяют находить самые энергоэффективные решения для каждого объекта. Собственные разработки в сфере диспетчеризации делают эксплуатацию максимально комфортной для персонала. Тот факт, что обратившись один раз, заказчики работают с этой компанией годами, доверяя ей все последующие очереди строительства, доказывает высокий уровень профессионализма и  ответственности. '
    ],
    images: require('../../shared/assets/images/partners/servicegazstroy.png'),
    site: 'https://servisgazstroy.com/',
    email: 'info@servisgazstroy.com',
    phone: '8 (8172) 50-29-62',
  },
  {
    id: 'rus',
    title: 'АРПП «Отечественный софт»',
    description: [
      'Ассоциация разработчиков программных продуктов «Отечественный софт» — крупнейшее объединение российских производителей тиражируемого программного обеспечения. Ассоциация учреждена в 2009 году ведущими российскими разработчиками. На сегодняшний день  в составе АРПП более 300 компаний.',
        'Ассоциация является надежной отраслевой площадкой, создает условия для поиска партнеров и взаимодействия с государством, консолидирует игроков рынка для совместной работы над ключевыми вопросами развития ИТ-отрасли.',
        'АРПП «Отечественный софт» признана наиболее влиятельной ассоциацией в ИТ-отрасли в 2022 году по версии ТAdviser.'
    ],
    images: require('../../shared/assets/images/partners/rus.png'),
    site: 'https://arppsoft.ru/',
    email: 'office@arppsoft.ru',
    phone: '+7 (495) 728-89-59',
  },
  {
    id: 'ick',
    title: 'ИЦК Металлургия',
    description: [
      'Индустриальные центры компетенций (ИЦК) созданы в 2022 году по итогам конференции «Цифровая индустрия промышленной России» по поручению Председателя Правительства РФ Михаила Мишустина. Деятельность ИЦК ориентирована на обеспечение ускоренного замещения зарубежных аналогов российскими отраслевыми цифровыми решениями в отраслях экономики и достижение технологичного суверенитета Российской Федерации.',
      'Проекты ИЦК направлены на разработку и внедрение российских цифровых продуктов и решений, необходимых для замещения используемых зарубежных продуктов.',
      'В состав ИЦК входят ведущие индустриальные заказчики и разработчики программного обеспечения. ИЦК «Металлургия» возглавляет «Северсталь».'
    ],
    images: require('../../shared/assets/images/partners/ick.png'),
    site: 'https://ицк-металлургия.рф/',
  },
  {
    id: 'fuels-digest',
    title: 'FUELS Digest',
    description: [
      'FUELS Digest - цифровой сервис глобального мониторинга технологической и аналитической документации в области производства и применения нефтяных и альтернативных топлив, присадок, процессов, катализаторов.',
      'Среди крупнейших подписчиков сервиса НПЗ ПАО «НК «Роснефть», ПАО «АНК «Башнефть», ПАО «НОВАТЭК», ООО «КИНЕФ», АО «ТАИФ-НК», ПАО «Татнефть» имени В.Д. Шашина, ПАО «Газпром», а также компании-производители присадок, научно-исследовательские институты.',
    ],
    images: require('../../shared/assets/images/partners/fuels-digest.jpg'),
    site: 'https://fuelsdigest.com/',
  },
  {
    id: 'petrochemicals',
    title: 'Журнал "Нефтепереработка и нефтехимия"',
    description: [
      'Журнал "Нефтепереработка и нефтехимия" с 1966 года служит важным ресурсом для специалистов нефтеперерабатывающей и нефтехимической отраслей, освещая научные и технологические достижения, актуальные проблемы, а также лучшие практики.',
      'Журнал включен в официальный список ВАК и проходит строгий процесс рецензирования, что обеспечивает высокое качество и актуальность публикуемых материалов.',
    ],
    images: require('../../shared/assets/images/partners/petrochemicals.jpg'),
    site: 'https://www.npnh.ru/',
  },
  {
    id: 'expert-network',
    title: 'Экспертная сеть "Северсталь"',
    description: [
      'Экспертная сеть «Северстали» это совокупность экспертных сообществ, созданных для обмена знаниями, опытом и идеями между специалистами из различных компаний, объединенных общей целью.'
    ],
    images: require('../../shared/assets/images/partners/expert-network.png'),
    site: 'https://innovations.severstal.com/expert-network/',
  },
];

export const announcements: any = [
  {
    id: 1,
    status: "",
    year: "2026",
    title: "EVO.INDUSTRY",
    titleUrl: "digitalization-industry",
    date: "Ноябрь 2026",
    location: "г. Череповец, 18-20 ноября",
    description: "ВСЕРОССИЙСКИЙ ФОРУМ ЦИФРОВИЗАЦИИ ПРОМЫШЛЕННОСТИ",
    tags: [
      {
        id: 1,
        tag: "ГМК"
      },
      {
        id: 2,
        tag: "ТЭК"
      },
      {
        id: 3,
        tag: "Нефтехимия"
      },
      {
        id: 4,
        tag: "Машиностроение"
      },
      {
        id: 5,
        tag: "Авиастроение"
      },
    ],
  },
  {
    id: 5,
    status: "",
    year: "2026",
    title: "EVO.INDUSTRY",
    titleUrl: "transport-logistics",
    date: "Ноябрь 2026",
    location: "г. Череповец, 9-11 декабря",
    description: "ВСЕРОССИЙСКИЙ ФОРУМ • ТРАНСПОРТ И ЛОГИСТИКА",
    tags: [
      {
        id: 1,
        tag: "ГМК"
      },
      {
        id: 2,
        tag: "ТЭК"
      },
      {
        id: 3,
        tag: "Нефтехимия"
      },
      {
        id: 4,
        tag: "Машиностроение"
      },
      {
        id: 5,
        tag: "Ритейл"
      },
      {
        id: 6,
        tag: "FMCG"
      },
    ],
  },
]

export const archive: any = [
  {
    id: 2,
    numberPhotos: "8 фото",
    title: "EVO.INDUSTRY",
    titleUrl: "energy-ecology",
    description: "ЦИФРОВИЗАЦИЯ 4.0: ЭНЕРГЕТИКА • ТОиР • ЭКОЛОГИЯ",
    date: "Октябрь 2025",
    location: "Москва",
    images: require('../../shared/assets/images/2025.jpg'),
  },
  {
    id: 3,
    numberPhotos: "6 фото",
    title: "EVO.INDUSTRY",
    description: "ВСЕРОССИЙСКИЙ ФОРУМ ТОиР",
    titleUrl: "toir",
    date: "Апрель 2026",
    location: " г.Череповец",
    images: require('../../shared/assets/images/04.2026.jpg'),
  },
  {
    id: 4,
    numberPhotos: "10 фото",
    title: "EVO.INDUSTRY",
    titleUrl: "energy",
    description: "ВСЕРОССИЙСКИЙ ФОРУМ ЭНЕРГЕТИКОВ",
    date: "Июнь 2026",
    location: " г.Череповец",
    images: require('../../shared/assets/images/06.2026.jpg'),
  },
]